// Public pixel identifier; never put a conversion API credential in browser code.
const PIXEL_ID = 'PzvJQR4vKVhUS9DZ218bVM';
const CONSENT_KEY = 'bliss_ads_measurement_consent';
type Queue = ((...args: unknown[]) => void) & { q?: unknown[][] };
let consent = true;
let initialized = false;
const measured = new Set<string>();

function allowedHost() {
  return typeof window !== 'undefined' && window.location.hostname === 'design.blissbunkbeds.com';
}
function privacyOptOut() {
  return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true || navigator.doNotTrack === '1';
}
function pixel() {
  return (window as Window & { oaiq?: Queue }).oaiq;
}
export function hasAdMeasurementConsent(): boolean {
  if (!allowedHost() || privacyOptOut()) return false;
  try { return sessionStorage.getItem(CONSENT_KEY) !== 'no'; } catch { return consent; }
}
export function setAdMeasurementConsent(value: boolean): void {
  if (!allowedHost()) return;
  consent = value && !privacyOptOut();
  try { sessionStorage.setItem(CONSENT_KEY, consent ? 'yes' : 'no'); } catch { /* optional */ }
  try {
    if (!consent) { pixel()?.('consent', false); return; }
    initializeAdMeasurement();
    pixel()?.('consent', true);
  } catch { /* Measurement must never block the customer flow. */ }
}
export function initializeAdMeasurement(): void {
  if (initialized || !hasAdMeasurementConsent()) return;
  const host = window as Window & { oaiq?: Queue };
  if (!host.oaiq) {
    const queue: Queue = (...args: unknown[]) => { queue.q!.push(args); };
    queue.q = [];
    host.oaiq = queue;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://bzrcdn.openai.com/sdk/oaiq.min.js';
    document.head.appendChild(script);
  }
  host.oaiq('consent', true);
  host.oaiq('init', { pixelId: PIXEL_ID });
  initialized = true;
}

/** Only call after the server confirms a new inquiry was saved. */
export function measureSavedInquiry(quoteRequestId: string): void {
  try {
    if (!hasAdMeasurementConsent() || !quoteRequestId) return;
    const key = `bliss_ads_lead:${quoteRequestId}`;
    if (measured.has(key)) return;
    try { if (sessionStorage.getItem(key)) return; } catch { /* optional */ }
    initializeAdMeasurement();
    const send = pixel();
    if (!send) return;
    send('measure', 'lead_created', { type: 'customer_action' }, { event_id: `bliss_lead_${quoteRequestId}` });
    measured.add(key);
    try { sessionStorage.setItem(key, '1'); } catch { /* optional */ }
  } catch { /* A blocked pixel must never turn a successful save into a failure. */ }
}

